import * as React from "react";
const SvgFiRrHamburger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hamburger_svg__a)">
      <path
        fill="#062147"
        d="M24 14.006a2.98 2.98 0 0 0-1-2.219V10A10.01 10.01 0 0 0 13 0h-2A10.01 10.01 0 0 0 1 10v1.837A3.137 3.137 0 0 0 1 16.4v.6a7.01 7.01 0 0 0 7 7h8a7.01 7.01 0 0 0 7-7v-.774a2.98 2.98 0 0 0 1-2.22M2.812 15.158a1.1 1.1 0 0 1 .282-2.152H21a1 1 0 0 1 0 2h-4c-1.956 0-3.98.788-6.364 2.481a2.87 2.87 0 0 1-3.271 0c-.228-.162-.447-.331-.667-.5a7.5 7.5 0 0 0-3.886-1.829M3 10a8.01 8.01 0 0 1 8-8h2a8.01 8.01 0 0 1 8 8v1.006l-18 .01zm13 12H8a4.994 4.994 0 0 1-4.975-4.755 6.24 6.24 0 0 1 2.454 1.327c.239.185.479.369.729.546a4.89 4.89 0 0 0 5.584 0A9.4 9.4 0 0 1 17 17.006h4A5 5 0 0 1 16 22M9 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M6 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hamburger_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHamburger;
